import React from 'react'
import * as wjrGrid from '@grapecity/wijmo.react.grid';
import * as wjGrid from '@grapecity/wijmo.grid';
import { typeDetailsForm } from '../../../../pages/ContractRegist';


interface Prop {
  detailsform: typeDetailsForm[] | undefined | null,
}

const DetailsEditForm: React.FC<Prop> = (props) => {
  const { detailsform } = props

  const onInitialized = (grid: any) => {
    // create extra header row
    var extraRow = new wjGrid.Row();
    extraRow.allowMerging = true;
    //
    // add extra header row to the grid
    var panel = grid.columnHeaders;
    panel.rows.splice(0, 0, extraRow);
    //
    // populate the extra header row
    for (let colIndex = 0; colIndex <= 1; colIndex++) {
      panel.setCellData(0, colIndex, 'サポート対象ハードウェア');
    }
    for (let colIndex = 2; colIndex <= 3; colIndex++) {
      panel.setCellData(0, colIndex, 'サポート対象ソフトウェア');
    }
    for (let colIndex = 5; colIndex <= 6; colIndex++) {
      panel.setCellData(0, colIndex, '仮想環境');
    }
    //
    // merge "仮想有無" and "HW保守契約種類" and "備考" headers vertically
    ['virtualEnvflag', 'hwHoshu', 'keiyakuNote'].forEach(function (binding) {
      let col = grid.getColumn(binding);
      col.allowMerging = true;
      panel.setCellData(0, col.index, col.header);
    });
    //
    // center-align merged header cells
    grid.formatItem.addHandler(function (s: any, e: any) {
      if (e.panel === s.columnHeaders && e.range.rowSpan > 1) {
        var html = e.cell.innerHTML;
        e.cell.innerHTML = '<div class="v-center">' + html + '</div>';
      }
    });
    grid.autoGenerateColumns = false;
    grid.itemsSource = detailsform;
  }
  return (
    <React.Fragment>
      <wjrGrid.FlexGrid allowMerging="ColumnHeaders" alternatingRowStep={0} initialized={onInitialized} itemsSource={detailsform} autoRowHeights={true}>
        <wjrGrid.FlexGridColumn binding="hwType" header="タイプ" wordWrap={true}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn binding="hwSerial" header="シリアル" wordWrap={true}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn binding="swOs" header="OS" wordWrap={true}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn binding="swApl" header="アプリケーション" wordWrap={true} minWidth={132}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn binding="virtualEnvflag" header="仮想 有・無" wordWrap={true} allowMerging={true}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn binding="virtualOs" header="導入仮想OS" wordWrap={true}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn binding="virtualApl" header="導入仮想アプリケーション" wordWrap={true} minWidth={189}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn binding="hwHoshu" header="HW保守契約種類" wordWrap={true} allowMerging={true}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn binding="keiyakuNote" header="備考" wordWrap={true} allowMerging={true}></wjrGrid.FlexGridColumn>
      </wjrGrid.FlexGrid>
    </React.Fragment>
  )
}

export default DetailsEditForm